// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import Vue2TouchEvents from 'vue2-touch-events'
import Utils from './plugins/Utils'
import Easing from './plugins/Easing'
import ScrollTo from './plugins/ScrollTo'
import Sticky from './directives/sticky'
import LazyLoad from './directives/lazy-load'
import VeeValidate from 'vee-validate'
import Moment from 'vue-moment'
// import VueAnalytics from 'vue-analytics'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import 'vue-awesome/icons/search'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/phone'
import 'vue-awesome/icons/map-marker'
import 'vue-awesome/icons/paper-plane-o'
import 'vue-awesome/icons/facebook-f'
import 'vue-awesome/icons/shopping-basket'
import 'vue-awesome/icons/industry'
import 'vue-awesome/icons/cubes'
import 'vue-awesome/icons/video-camera'
import 'vue-awesome/icons/chevron-up'
import 'vue-awesome/icons/chevron-right'
import 'vue-awesome/icons/chevron-left'
import 'vue-awesome/icons/ellipsis-h'
import 'vue-awesome/icons/check'
import Icon from 'vue-awesome/components/Icon'

Vue.component('icon', Icon)
Vue.config.productionTip = false

Vue.use(Moment)
Vue.use(VeeValidate)
Vue.use(Utils)
Vue.use(Easing)
Vue.use(ScrollTo)
Vue.use(Vue2TouchEvents)
Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB8klBrTutZkfzpNWPivz4DxwUVbfqjeDs',
    libraries: 'places'
  }
})
/*Vue.use(VueAnalytics, {
  id: 'UA-106536080-1',
  autoTracking: {
    page: false
  }
})*/

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js